module.exports = __webpack_public_path__ + "img/delivery.2177aa50.webp";